import http from './http-util'
import config from '../../../config'

class TransactionServiceApi {
  static creditTransaction = (body, token) => {
    return http.post(
      token,
      `${config.transactionServiceUrl}/transactions/credit_transaction`,
      JSON.stringify(body),
    )
  }

  static getCreditTransactions = (accountNumber, transactionId) => token => {
    return http.get(
      token,
      `${config.transactionServiceUrl}/transactions/account_number/${accountNumber}/transactionid/${transactionId}/credit_transaction`,
    )
  }
}

export default TransactionServiceApi
